import { DOCUMENT } from "@angular/common";
import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";

@Component({
  selector: "vw-modal",
  templateUrl: "./modal.component.html",
})
export class ModalComponent implements OnInit, OnDestroy {
  @Input() title?: string;
  @Input() closeable?: boolean;

  @Output() close$ = new EventEmitter<void>();

  constructor(@Inject(DOCUMENT) private doc: Document) {}

  ngOnInit() {
    const curOpen =
      Number.parseInt(document.body.dataset.openModals || "0", 10) | 0;
    document.body.dataset.openModals = (curOpen + 1).toFixed(0);
    this.doc.body.classList.add("modal-open");
  }

  ngOnDestroy(): void {
    const curOpen =
      Number.parseInt(document.body.dataset.openModals || "0", 10) | 0;
    const newOpen = Math.max(curOpen - 1, 0);
    if (newOpen === 0) {
      delete this.doc.body.dataset.openModals;
      this.doc.body.classList.remove("modal-open");
    } else {
      document.body.dataset.openModals = newOpen.toFixed(0);
    }
  }

  close(): void {
    if (this.closeable) {
      this.close$.emit();
    }
  }
}
